import React, { useState } from "react";
import { Phone, X, CalendarClock, MessageCircle } from "lucide-react";

export default function ScheduleCallFAB() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="schedule-fab">
      {open && (
        <div className="absolute bottom-20 right-0 w-80 bg-white rounded-2xl shadow-2xl border border-[#E1E8E2] p-5 fade-up">
          <button onClick={() => setOpen(false)} className="absolute top-3 right-3 text-[#5A6B66] hover:text-[#0A2520]">
            <X size={18} />
          </button>
          <div className="chip mb-3">Free · No commitment</div>
          <h4 className="font-display font-bold text-xl text-[#0A2520] mb-1.5">Talk to an IP expert</h4>
          <p className="text-sm text-[#5A6B66] mb-4 leading-relaxed">30-minute call with a senior IP advisor — in your preferred language.</p>
          <div className="space-y-2">
            <a href="tel:1800-UDHYAK-1" className="btn-primary w-full justify-center text-sm" data-testid="fab-call-now">
              <Phone size={14} /> Call 1800-UDHYAK-1
            </a>
            <button className="btn-outline w-full justify-center text-sm" data-testid="fab-schedule">
              <CalendarClock size={14} /> Schedule for later
            </button>
            <button className="btn-outline w-full justify-center text-sm" data-testid="fab-whatsapp">
              <MessageCircle size={14} /> WhatsApp us
            </button>
          </div>
          <div className="text-xs text-[#5A6B66] mt-4 text-center">Avg. callback in 12 minutes</div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="bg-[#0E6E5E] hover:bg-[#0B5447] text-white rounded-full w-16 h-16 flex items-center justify-center shadow-2xl pulse-ring transition"
        data-testid="schedule-fab-btn"
      >
        {open ? <X size={22} /> : <Phone size={22} />}
      </button>
    </div>
  );
}
